export default "__VITE_ASSET__CeVXmcof__"